import { Badge, Breadcrumb, Card, Col, Collapse, Icon, Popconfirm, Row, Spin, Tabs, Tooltip } from 'antd'
import Documents from '../../../../../components/Common/Documents/DocumentsCont'
import WorkOrdersCont from '../../../../../components/People/Member/Contract/ViewContract/WorkOrders/WorkOrdersCont'
import RefreshButton from '../../../../../elements/Buttons/RefreshButton'

import InfoText from '../../../../../elements/InfoText'
import StateSelect from '../../../../../elements/Select/StateSelect'
import Status from '../../../../../elements/Status'
import { get } from 'lodash'
import { strVal } from '../../../../../modules/Utils'
import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import Communication from '../Form/Communication'
import Entitlements from '../Form/Entitlements'
import KeyTerms from '../Form/KeyTerms'
import Overview from '../Form/Overview'
import Payroll from '../Form/Payroll'
import style from './style.css'

const { Panel } = Collapse
const { TabPane } = Tabs

class ViewContract extends Component {
  render () {
    const {
      member,
      employee,
      fetching,
      contract,
      id,
      actions,
      handleOps,
      fetch,
      updateContractState,
      updatingState,
      overviewCmpRef,
      keyTermsCmpRef,
      payrollCmpRef,
      communicationCmpRef,
    } = this.props
    const Operations = ({ contract, ...rest }) => {
      const ops = actions.map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleOps(a.key, contract)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
      ops.push(<RefreshButton onClick={fetch}/>)
      return (
        <div {...rest}>
          {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr]) : []}
        </div>
      )
    }
    return (
      <Fragment>
        <Card loading={fetching}>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>People</Breadcrumb.Item>
              <Breadcrumb.Item href="#/people/dashboard/#team">Team List</Breadcrumb.Item>
              <Breadcrumb.Item href={`#/people/member/${id}/#contracts`}>{member.fn}</Breadcrumb.Item>
              <Breadcrumb.Item>{contract.code}</Breadcrumb.Item>
            </Breadcrumb>
            <h3 className={style.title}>
              <h3 className={'icon-text-header'}>
                <Icon
                  type="barcode"
                  style={{
                    marginRight: '5px',
                    color: '#08c',
                  }}
                />
                <Tooltip title="Contract  Code">{strVal(contract, 'code')}</Tooltip>
                {' - ' + strVal(contract, 'title')}
                {contract.default === true && (
                  <Tooltip placement="top" title="Default Contract">
                    <Badge
                      dot
                      style={{
                        background: '#2db731',
                        margin: '10px',
                      }}
                    />
                  </Tooltip>
                )}
              </h3>
              <Status value={strVal(contract, 'status')}/>
              <Row style={{ marginTop: 10 }}>
                <Col span={2}>Service State:</Col>
                <Col span={4}>
                  <StateSelect value={get(contract, 'state')} onChange={updateContractState} disabled={updatingState}/>
                </Col>
                <Col span={1}>
                  <Spin style={{ marginLeft: 10 }} spinning={updatingState}/>
                </Col>
              </Row>
              <Operations style={{ marginTop: '10px' }} contract={contract} status={strVal(contract, 'status')}/>
            </h3>
            <p className={style.paragraph}>{member.fn} Contract Details</p>
          </Row>
        </Card>
        <Row style={{ paddingTop: '10px' }}>
          <Card loading={fetching} style={{ minHeight: '542px' }}>
            <Row style={{ paddingTop: '10px' }}>
              <Tabs
                defaultActiveKey={get(this.props, 'location.hash') || '#dashboard'}
                onChange={(key) => this.props.history.push(key)}>
                <TabPane
                  tab={
                    <span>
                      <Icon type="info-circle"/>
                      Details
                    </span>
                  }
                  key="#dashboard">
                  <InfoText text={'To Update Contract Details please click on Update Button above.'}/>
                  <Collapse bordered={false} defaultActiveKey={['1']}>
                    <Panel header={<h3>Contract Overview</h3>} key="1">
                      <Overview employee={employee} ref={overviewCmpRef} contract={contract} type={'view'}/>
                    </Panel>
                    <Panel header={<h3>Key Terms</h3>} key="2">
                      <KeyTerms
                        employee={employee}
                        ref={keyTermsCmpRef}
                        contract={contract}
                        updateContract={() => console.log('Not Implemented')}
                        type={'view'}
                      />
                    </Panel>
                    <Panel header={<h3>Pay Details</h3>} key="4">
                      <Payroll
                        employee={employee}
                        ref={payrollCmpRef}
                        contract={contract}
                        type={'view'}
                        updateContract={() => console.log('Not Implemented')}
                      />
                    </Panel>
                    <Panel header={<h3>Entitlements</h3>} key="5">
                      <Entitlements
                        employee={employee}
                        ref={payrollCmpRef}
                        contract={contract}
                        loading={fetching}
                        type={'view'}
                      />
                    </Panel>
                    <Panel header={<h3>Communication</h3>} key="6">
                      <Communication employee={employee} ref={communicationCmpRef} contract={contract}/>
                    </Panel>
                  </Collapse>
                </TabPane>
                <TabPane
                  disabled={!(contract.blanket === true)}
                  tab={
                    <span>
                      <Icon type="file-text"/>
                      Work Orders
                    </span>
                  }
                  key="#work-orders">
                  <WorkOrdersCont loading={fetching} owner={contract} employee={employee} member={member}/>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="folder-open"/>
                      Documents
                    </span>
                  }
                  key="#docs">
                  <Documents owner={contract}/>
                </TabPane>
              </Tabs>
            </Row>
          </Card>
        </Row>
      </Fragment>
    )
  }
}

export default withRouter(ViewContract)
